type LoyaltyUpgradeTarget = {
  totalsKey: 'roomUpgradeTotals' | 'packageUpgradeTotals'
  totals: App.Checkout.ItemViewTotals
}

function getAppliedAccommodationLoyaltyUpgradeTarget(
  availability: App.Checkout.AccommodationItemViewLoyaltyUpgradeAvailability | undefined,
  upgradeType: App.LoyaltyStayUpgradeType | undefined,
): LoyaltyUpgradeTarget | undefined {
  if (!availability) return

  if (
    upgradeType === 'room' &&
    (availability.upgradeAvailabilityType === 'room-only' || availability.upgradeAvailabilityType === 'room-and-package')
  ) {
    return {
      totalsKey: 'roomUpgradeTotals',
      totals: availability.roomUpgradeTotals,
    }
  }

  if (
    upgradeType === 'package' &&
    (availability.upgradeAvailabilityType === 'package-only' || availability.upgradeAvailabilityType === 'room-and-package')
  ) {
    return {
      totalsKey: 'packageUpgradeTotals',
      totals: availability.packageUpgradeTotals,
    }
  }
}

export function getAppliedAccommodationLoyaltyUpgradeTotals(
  availability: App.Checkout.AccommodationItemViewLoyaltyUpgradeAvailability | undefined,
  upgradeType: App.LoyaltyStayUpgradeType | undefined,
): App.Checkout.ItemViewTotals | undefined {
  return getAppliedAccommodationLoyaltyUpgradeTarget(availability, upgradeType)?.totals
}

export function addDynamicPricingSurchargeToAppliedAccommodationLoyaltyUpgrade(
  availability: App.Checkout.AccommodationItemViewLoyaltyUpgradeAvailability | undefined,
  upgradeType: App.LoyaltyStayUpgradeType | undefined,
  surchargeAmount: number | undefined,
): App.Checkout.AccommodationItemViewLoyaltyUpgradeAvailability | undefined {
  const target = getAppliedAccommodationLoyaltyUpgradeTarget(availability, upgradeType)
  if (!availability || !target || surchargeAmount === undefined || target.totals.dynamicPricingSurchargeIncludedInSource) {
    return availability
  }

  return {
    ...availability,
    [target.totalsKey]: {
      ...target.totals,
      dynamicPricingSurcharge: surchargeAmount,
    },
  }
}
